// extracted by mini-css-extract-plugin
export default {"lds-ring":"Spinner-module__lds-ring___Dcqdf"};